import { IS_STAGING, DebugLog } from "../main";
import { GetDateTimeFromDateAsKey } from "../utilities/date";

export var DB = null;
export var BASEDB = null;
var TRANSACTIONDB = null;

function InitializeBaseDBNames() {
  BASEDB = {
    PROFILES: "profiles",
    BANTAY_KARD: "bantayKard",
    MESSAGE_BOX: "messageBox",
    USER_VALIDATION: "userValidation",

    // companies
    COMPANIES: "companies",

    // diagnostics and clinic
    APPOINTMENTS: "appointments",
    DIAGNOSTIC_CLINICS: "diagnosticClinics",
    DIAGNOSTIC_SCHEDULES: "diagnosticSchedules",
    DIAGNOSTIC_PACKAGES: "diagnosticPackages",
    DIAGNOSTIC_ATTENDEE: "diagnosticAttendee",
    MEDICAL_HISTORY: "medicalhistory",
    TEST_SETTINGS: "testSettings",
    DIAGNOSTIC_HOMESERVICE: "diagnosticHomeService",

    // insurance
    INSURANCE_ACCOUNT: "insuranceAccount",
    INSURANCE_HISTORY: "insurancehistory",
    INSURANCE_PACKAGE: "insurancePackage",

    // LGU services
    LGU_ATTENDEE: "lguAttendee",
    LGU_LOCATIONS: "lguLocations",
    LGU_SCHEDULES: "lguSchedules",
    LGU_SERVICES: "lguServices",
    LGU_VALIDATION: "lguValidation",

    // OFFSITE services
    OFFSITE_ATTENDEE: "offsiteAttendee",
    OFFSITE_LOCATIONS: "offsiteLocations",
    OFFSITE_SCHEDULES: "offsiteSchedules",
    OFFSITE_SERVICES: "offsiteServices",
    OFFSITE_SUBMISSIONS: "offsiteSubmissions",
    OFFSITE_VALIDATION: "offsiteValidation",

    // store
    ADDTOCART: "addtocart",
    CATALOG: "catalog",
    CHECKOUT: "checkout",
    DELIVERY: "delivery",
    DISPLAY: "display",
    PRODUCTS: "products",
    PRODUCTVARIANT: "productvariant",
    STORESETTINGS: "storesettings",
    PRODUCTIMAGES: "productimages",

    SETTINGS: "settings",

    COVID_VACCINE: "covidVaccine",
  };

  Object.freeze(BASEDB);
}

function InitializeTransactionDBNames(PREFIX) {
  const TRANSACTIONS = PREFIX + "transactions_";

  TRANSACTIONDB = {
    CATALOG: TRANSACTIONS + BASEDB.CATALOG,
    LGU_ATTENDEE: TRANSACTIONS + BASEDB.LGU_ATTENDEE,
    LGU_SCHEDULES: TRANSACTIONS + BASEDB.LGU_SCHEDULES,
    OFFSITE_ATTENDEE: TRANSACTIONS + BASEDB.OFFSITE_ATTENDEE,
    OFFSITE_SCHEDULES: TRANSACTIONS + BASEDB.OFFSITE_SCHEDULES,
    MESSAGE_BOX: TRANSACTIONS + BASEDB.MESSAGE_BOX,
    PRODUCTS: TRANSACTIONS + BASEDB.PRODUCTS,
    PROFILES: TRANSACTIONS + BASEDB.PROFILES,
    STORAGE: TRANSACTIONS + "storage",
    USER_SESSION: TRANSACTIONS + "userSession",

    COVID_VACCINE: TRANSACTIONS + BASEDB.COVID_VACCINE,
  };

  Object.freeze(TRANSACTIONDB);
}

function InitializeDBNamesWorker(PREFIX) {
  DB = {
    PROFILES: PREFIX + BASEDB.PROFILES,
    BANTAY_KARD: PREFIX + BASEDB.BANTAY_KARD,
    MESSAGE_BOX: PREFIX + BASEDB.MESSAGE_BOX,
    USER_VALIDATION: PREFIX + BASEDB.USER_VALIDATION,

    // companies
    COMPANIES: PREFIX + BASEDB.COMPANIES,

    // diagnostics and clinic
    APPOINTMENTS: PREFIX + BASEDB.APPOINTMENTS,
    DIAGNOSTIC_CLINICS: PREFIX + BASEDB.DIAGNOSTIC_CLINICS,
    DIAGNOSTIC_SCHEDULES: PREFIX + BASEDB.DIAGNOSTIC_SCHEDULES,
    DIAGNOSTIC_PACKAGES: PREFIX + BASEDB.DIAGNOSTIC_PACKAGES,
    DIAGNOSTIC_ATTENDEE: PREFIX + BASEDB.DIAGNOSTIC_ATTENDEE,
    MEDICAL_HISTORY: PREFIX + BASEDB.MEDICAL_HISTORY,
    TEST_SETTINGS: PREFIX + BASEDB.TEST_SETTINGS,
    DIAGNOSTIC_HOMESERVICE: PREFIX + BASEDB.DIAGNOSTIC_HOMESERVICE,

    // insurance
    INSURANCE_ACCOUNT: PREFIX + BASEDB.INSURANCE_ACCOUNT,
    INSURANCE_HISTORY: PREFIX + BASEDB.INSURANCE_HISTORY,
    INSURANCE_PACKAGE: PREFIX + BASEDB.INSURANCE_PACKAGE,

    // LGU services
    LGU_ATTENDEE: PREFIX + BASEDB.LGU_ATTENDEE,
    LGU_LOCATIONS: PREFIX + BASEDB.LGU_LOCATIONS,
    LGU_SCHEDULES: PREFIX + BASEDB.LGU_SCHEDULES,
    LGU_SERVICES: PREFIX + BASEDB.LGU_SERVICES,
    LGU_VALIDATION: PREFIX + BASEDB.LGU_VALIDATION,

    // OFFSITE services
    OFFSITE_ATTENDEE: PREFIX + BASEDB.OFFSITE_ATTENDEE,
    OFFSITE_LOCATIONS: PREFIX + BASEDB.OFFSITE_LOCATIONS,
    OFFSITE_SCHEDULES: PREFIX + BASEDB.OFFSITE_SCHEDULES,
    OFFSITE_SERVICES: PREFIX + BASEDB.OFFSITE_SERVICES,
    OFFSITE_SUBMISSIONS: PREFIX + BASEDB.OFFSITE_SUBMISSIONS,
    OFFSITE_VALIDATION: PREFIX + BASEDB.OFFSITE_VALIDATION,

    // store
    ADDTOCART: PREFIX + BASEDB.ADDTOCART,
    CATALOG: PREFIX + BASEDB.CATALOG,
    CHECKOUT: PREFIX + BASEDB.CHECKOUT,
    DELIVERY: PREFIX + BASEDB.DELIVERY,
    DISPLAY: PREFIX + BASEDB.DISPLAY,
    PRODUCTS: PREFIX + BASEDB.PRODUCTS,
    PRODUCTVARIANT: PREFIX + BASEDB.PRODUCTVARIANT,
    STORESETTINGS: PREFIX + BASEDB.STORESETTINGS,
    PRODUCTIMAGES: PREFIX + BASEDB.PRODUCTIMAGES,

    SETTINGS: PREFIX + BASEDB.SETTINGS,

    COVID_VACCINE: PREFIX + BASEDB.COVID_VACCINE,
  };

  Object.freeze(DB);
}

export function InitializeDBNames() {
  const PREFIX = IS_STAGING ? "test_" : "";

  InitializeBaseDBNames();
  InitializeTransactionDBNames(PREFIX);
  InitializeDBNamesWorker(PREFIX);
}

const CURRENT_SESSION_ID = "medisureSessionId";
const CURRENT_USER = "medisureCurrentUser";
const CURRENT_USER_UID = "medisureCurrentUserUid";
const CURRENT_USER_EMAIL = "medisureCurrentUserEmail";

function GetValue(key) {
  const item = window.sessionStorage.getItem(key);
  return "null" === item ? "" : item;
}

export function GetCurrentSessionId() {
  return GetValue(CURRENT_SESSION_ID);
}

export function GetCurrentUser() {
  return GetValue(CURRENT_USER) || "Not specified";
}

export function GetCurrentUserEmail() {
  return GetValue(CURRENT_USER_EMAIL);
}

export function GetCurrentUserUid() {
  return GetValue(CURRENT_USER_UID);
}

function SetValueOrRemove(key, value) {
  if (value) {
    window.sessionStorage.setItem(key, value);
  } else {
    window.sessionStorage.removeItem(key);
  }
}

export function SetCurrentSessionId(value = "") {
  return SetValueOrRemove(CURRENT_SESSION_ID, value);
}

export function SetCurrentUserEmail(value = "") {
  return SetValueOrRemove(CURRENT_USER_EMAIL, value);
}

export function SetCurrentUserName(value = "") {
  return SetValueOrRemove(CURRENT_USER, value);
}

export function SetCurrentUserUid(value = "") {
  return SetValueOrRemove(CURRENT_USER_UID, value);
}

function LogUserLog(operation) {
  return new Promise((resolve) => {
    let currentSessionId = GetCurrentSessionId();

    if (currentSessionId) {
      db.collection(TRANSACTIONDB.USER_SESSION)
        .doc(currentSessionId)
        .set(
          {
            [GetDateTimeFromDateAsKey()]: {
              operation: operation,
              uid: GetCurrentUserUid(),
            },
          },
          { merge: true }
        )
        .then(() => resolve())
        .catch(() => resolve());
    } else {
      resolve();
    }
  });
}

export function SetCurrentUser(thisCurrentUserUid = "", thisCurrentUser = "") {
  if (thisCurrentUserUid) {
    SetCurrentUserName(thisCurrentUser);
    SetCurrentUserUid(thisCurrentUserUid);

    let doc = db.collection(TRANSACTIONDB.USER_SESSION).doc();
    doc
      .set(
        {
          [GetDateTimeFromDateAsKey()]: {
            operation: "Logged in",
            uid: thisCurrentUserUid,
          },
        },
        { merge: true }
      )
      .then(() => {
        SetCurrentSessionId(doc.id);
        LogUserLog("Logged in");
      });
  } else {
    SetCurrentUserName();
    SetCurrentUserUid();

    if (GetCurrentSessionId()) {
      LogUserLog("Logged out").then(() => SetCurrentSessionId());
    }
  }
}

var db = null;
export function SetDB(thisDb) {
  db = thisDb;
}

function LogTransaction(collectionName, timestamp, operation, newValues) {
  return new Promise((resolve) => {
    let docData = db.collection(collectionName).doc();
    docData
      .set({
        timestamp: timestamp,
        initiatedBy: GetCurrentUserUid(),
        operation: operation,
        newValues: { ...newValues },
      })
      .then(() => {
        DebugLog(`Added to ${collectionName} - ${docData.id}`);
        resolve();
      })
      .catch(() => resolve());
  });
}

function LogBatchTransactionEntry(collectionName, timestamp, operation, id) {
  return new Promise((resolve) => {
    let docData = db.collection(collectionName).doc();
    docData
      .set({
        timestamp: timestamp,
        initiatedBy: GetCurrentUserUid(),
        operation: `queued for batch: ${operation}`,
        id: id,
      })
      .then(() => {
        DebugLog(`Added to ${collectionName} - ${docData.id}`);
        resolve();
      })
      .catch(() => resolve());
  });
}

//------------------------ LGU ATTENDEE TRANSACTIONS ------------------------//

export function LogLguAttendeeBatchTransactionEntry(timestamp, operation, id) {
  return new Promise((resolve) => {
    LogBatchTransactionEntry(
      TRANSACTIONDB.LGU_ATTENDEE,
      timestamp,
      operation,
      id
    ).then(() => resolve());
  });
}

//------------------------ LGU SCHEDULES TRANSACTIONS ------------------------//

export function LogLguSchedulesBatchTransactionEntry(timestamp, operation, id) {
  return new Promise((resolve) => {
    LogBatchTransactionEntry(
      TRANSACTIONDB.LGU_SCHEDULES,
      timestamp,
      operation,
      id
    ).then(() => resolve());
  });
}

export function LogLguSchedulesTransaction(timestamp, operation, newValues) {
  return new Promise((resolve) => {
    LogTransaction(
      TRANSACTIONDB.LGU_SCHEDULES,
      timestamp,
      operation,
      newValues
    ).then(() => resolve());
  });
}

//--------------------------- CATALOG TRANSACTIONS ---------------------------//

export function LogCatalogTransaction(timestamp, operation, newValues) {
  return new Promise((resolve) => {
    LogTransaction(TRANSACTIONDB.CATALOG, timestamp, operation, newValues).then(
      () => resolve()
    );
  });
}

function AddTransaction(
  transactionName,
  doc,
  timestamp,
  operation,
  targetUid,
  newValues
) {
  return new Promise((resolve) => {
    doc
      .set({
        timestamp: timestamp,
        initiatedBy: GetCurrentUserUid(),
        operation: operation,
        uid: targetUid,

        newValues: { ...newValues },
      })
      .then(() => {
        DebugLog("Added to", transactionName, "transaction", doc.id);
        resolve();
      });
  });
}

//------------------------ COVID VACCINE TRANSACTIONS ------------------------//

export function LogCovidVaccineTransaction(timestamp, operation, newValues) {
  return new Promise((resolve) => {
    LogTransaction(
      TRANSACTIONDB.COVID_VACCINE,
      timestamp,
      operation,
      newValues
    ).then(() => resolve());
  });
}

//------------------------- MESSAGE BOX TRANSACTIONS -------------------------//

export function LogMessageBoxTransaction(
  timestamp,
  operation,
  messageUid,
  newValues
) {
  return new Promise((resolve) => {
    let docData = db.collection(TRANSACTIONDB.MESSAGE_BOX).doc();
    AddTransaction(
      "message box",
      docData,
      timestamp,
      operation,
      messageUid,
      newValues
    ).then(() => resolve());
  });
}

//--------------------------- PRODUCT TRANSACTIONS ---------------------------//

export function LogProductTransaction(
  timestamp,
  operation,
  productDocUid,
  newValues
) {
  return new Promise((resolve) => {
    let docData = db.collection(TRANSACTIONDB.PRODUCTS).doc();
    AddTransaction(
      "product",
      docData,
      timestamp,
      operation,
      productDocUid,
      newValues
    ).then(() => resolve());
  });
}

//-------------------------- PROFILES TRANSACTIONS --------------------------//

export function LogProfilesTransaction(timestamp, operation, newValues) {
  return new Promise((resolve) => {
    LogTransaction(
      TRANSACTIONDB.PROFILES,
      timestamp,
      operation,
      newValues
    ).then(() => resolve());
  });
}

//--------------------------- STORAGE TRANSACTIONS ---------------------------//

export function LogStorageTransaction(timestamp, operation, data) {
  return new Promise((resolve) => {
    let docData = db.collection(TRANSACTIONDB.STORAGE).doc();
    docData
      .set({
        ...data,

        timestamp: timestamp,
        initiatedBy: GetCurrentUserUid(),
        operation: operation,
      })
      .then(() => {
        DebugLog("Added to storage transaction", docData.id);
        resolve();
      })
      .catch(() => resolve());
  });
}

export function LogUploadFailedTransaction(timestamp, path) {
  return new Promise((resolve) => {
    LogStorageTransaction(timestamp, "upload failed", { path: path }).then(() =>
      resolve()
    );
  });
}

export function LogUploadSucceededTransaction(timestamp, path, downloadUrl) {
  return new Promise((resolve) => {
    LogStorageTransaction(timestamp, "upload succeeded", {
      path: path,
      downloadUrl: downloadUrl,
    }).then(() => resolve());
  });
}

//-------------------------- STORESETTINGS ACTIONS --------------------------//

export function LoadProductCategories() {
  return new Promise((resolve, reject) => {
    db.collection(DB.STORESETTINGS)
      .doc("categories")
      .get()
      .then((doc) => {
        let categories = [];
        let data = doc.data();

        if (data && data.categories) {
          categories = [...data.categories];
        }

        resolve(categories);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//---------------------- OFFSITE ATTENDEE TRANSACTIONS ----------------------//

export function LogOffsiteAttendeeBatchTransactionEntry(
  timestamp,
  operation,
  id
) {
  LogBatchTransactionEntry(
    TRANSACTIONDB.OFFSITE_ATTENDEE,
    timestamp,
    operation,
    id
  );
}

//---------------------- OFFSITE SCHEDULES TRANSACTIONS ----------------------//

export function LogOffsiteSchedulesBatchTransactionEntry(
  timestamp,
  operation,
  id
) {
  LogBatchTransactionEntry(
    TRANSACTIONDB.OFFSITE_SCHEDULES,
    timestamp,
    operation,
    id
  );
}

export function LogOffsiteSchedulesTransaction(
  timestamp,
  operation,
  newValues
) {
  LogTransaction(
    TRANSACTIONDB.OFFSITE_SCHEDULES,
    timestamp,
    operation,
    newValues
  );
}

//-------------------------- USER ACTIVITY LOGGING --------------------------//

export function LogUserActivity(operation, newValues) {
  return new Promise((resolve) => {
    let currentSessionId = GetCurrentSessionId();

    if (currentSessionId) {
      db.collection(TRANSACTIONDB.USER_SESSION)
        .doc(currentSessionId)
        .set(
          {
            [GetDateTimeFromDateAsKey()]: {
              operation: operation,
              uid: GetCurrentUserUid(),
              newValues: { ...newValues },
            },
          },
          { merge: true }
        )
        .then(() => resolve())
        .catch(() => resolve());
    } else {
      resolve();
    }
  });
}

//-------------------------- PREBOOKING --------------------------//
export function GetPrebookingCount() {
  return new Promise((resolve, reject) => {
    db.collection(DB.COVID_VACCINE)
      .get()
      .then((querySnapshot) => {
        resolve(querySnapshot.size);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function GetPrebookingAttendee() {
  return new Promise((resolve, reject) => {
    db.collection(DB.COVID_VACCINE)
      .get()
      .then((snapshot) => {
        let attendee = [];
        snapshot.forEach((doc) => {
          attendee.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        resolve(attendee);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function GetPrebookingAttendeebyMunicipality(municipality) {
  return new Promise((resolve, reject) => {
    db.collection(DB.COVID_VACCINE)
      .where("location.municipality", "==", municipality.city)
      .get()
      .then((snapshot) => {
        let attendeem = [];
        snapshot.forEach((doc) => {
          attendeem.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        resolve(attendeem);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function GetPrebookingAttendeebyBarangay(barangay) {
  return new Promise((resolve, reject) => {
    db.collection(DB.COVID_VACCINE)
      .where("location.barangay", "==", barangay.barangay)
      .get()
      .then((snapshot) => {
        let attendeeb = [];
        snapshot.forEach((doc) => {
          attendeeb.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        resolve(attendeeb);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function DbGetLocations() {
  return db.collection("locations").get();
}
